<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Bekräfta</p>
			</header>
			<section class="modal-card-body">
				<p>{{ message }}</p>
				<span v-if="error" class="tag is-danger is-medium is-light mt-5">{{
					error
				}}</span>
			</section>

			<footer class="modal-card-foot">
				<button class="button is-dark" @click.once="confirm">
					<span class="icon"><i class="fas fa-trash"/></span>
					<span>Bekräfta</span>
				</button>
				<button class="button is-dark" @click="cancel">
					<span class="icon"><i class="fas fa-ban"/></span> <span>Avbryt</span>
				</button>
			</footer>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		message: {
			type: String,
			default: () => 'Test'
		},
		error: {
			type: String,
			default: ''
		}
	},
	methods: {
		confirm() {
			this.$emit('confirm');
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
